export enum Environment {
	PREVIEW     = 'preview',
	LOCAL       = 'local',
	DEVELOPMENT = 'development',
	TESTING     = 'testing',
	QA          = 'qa',
	PRODUCTION  = 'production',
}
